import React from 'react'
import { Editor, RichUtils } from 'draft-js'
import 'styles/d3/richtexteditor.scss'

const BLOCK_TYPES = [
  // { label: 'H1', style: 'header-one' },
  // { label: 'H2', style: 'header-two' },
  // { label: 'H3', style: 'header-three' },
  // { label: 'H4', style: 'header-four' },
  // { label: 'H5', style: 'header-five' },
  // { label: 'H6', style: 'header-six' },
  // { label: 'Blockquote', style: 'blockquote' },
  // { label: 'UL', style: 'unordered-list-item' },
  // { label: 'OL', style: 'ordered-list-item' },
  // { label: 'Code Block', style: 'code-block' },
]

class RichTextEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = { editorHasFocus: false }
    this.blockStyleControls = this.blockStyleControls.bind(this)
  }

  blockStyleControls = () => {
    const selection = this.props.editorState.getSelection()
    const blockType = this.props.editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType()

    return (
      <div className='block-type-toolbar'>
        {BLOCK_TYPES.map(type => (
          <button
            className={blockType === type.style ? 'active' : ''}
            key={type.label}
            onMouseDown={this.onToggleBlockType(type.style)}>
            {type.label}
          </button>
        ))}
      </div>
    )
  }

  onToggleInlineStyle = style => {
    return e => {
      e.preventDefault()
      this.props.onChange(RichUtils.toggleInlineStyle(this.props.editorState, style))
    }
  }

  onToggleBlockType = style => {
    return e => {
      e.preventDefault()
      this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, style))
    }
  }

  onKeyCommand = (command, editorState) => {
    const newEditorState = RichUtils.handleKeyCommand(editorState, command)
    if (newEditorState) {
      this.props.onChange(newEditorState)
    }
  }

  focus() {
    this.draftEditor.focus()
  }

  render() {
    const {
      editorState,
      placeholder,
      onChange,
      spellCheck,
      className = ' ',
      hasError,
      showToolbar,
      readOnly
    } = this.props
    const editorProps = { editorState, placeholder, onChange, spellCheck, readOnly }
    const currentStyle = editorState.getCurrentInlineStyle()
    const selection = editorState.getSelection()
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType()

    return (
      <div
        className={`${className}d3-editor${this.state.editorHasFocus ? ' focus' : ''}${readOnly ? ' read-only' : ''}${
          hasError ? ' error' : ''
        }`}
        onClick={() => this.draftEditor.focus()}>
        {showToolbar && this.state.editorHasFocus && (
          <div className='rich-text-toolbar'>
            {this.blockStyleControls()}
            <i
              className={blockType === 'ordered-list-item' ? 'fa fa-list-ol active' : 'fa fa-list-ol'}
              onMouseDown={this.onToggleBlockType('ordered-list-item')}
            />
            <i
              className={blockType === 'unordered-list-item' ? 'fa fa-list-ul active' : 'fa fa-list-ul'}
              onMouseDown={this.onToggleBlockType('unordered-list-item')}
            />
            <i
              className={currentStyle.has('BOLD') ? 'fa fa-bold active' : 'fa fa-bold'}
              onMouseDown={this.onToggleInlineStyle('BOLD')}
            />
            <i
              className={currentStyle.has('ITALIC') ? 'fa fa-italic active' : 'fa fa-italic'}
              onMouseDown={this.onToggleInlineStyle('ITALIC')}
            />
            <i
              className={currentStyle.has('UNDERLINE') ? 'fa fa-underline active' : 'fa fa-underline'}
              onMouseDown={this.onToggleInlineStyle('UNDERLINE')}
            />
          </div>
        )}
        <Editor
          onFocus={() => this.setState({ editorHasFocus: true })}
          onBlur={() => this.setState({ editorHasFocus: false })}
          ref={el => {
            this.draftEditor = el
          }}
          handleKeyCommand={this.onKeyCommand}
          {...editorProps}
        />
      </div>
    )
  }
}

export default RichTextEditor
